// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"7216":"e0af521e4695419d","9612":"8c187bfd992bbe21"}[chunkId] + ".js";
};